import { useT } from "../../i18n";
import { storeUrl } from "../../constants/mintlabApps";

// "Installing" pie for apps not out yet — purely decorative, shrinks per icon.
const RING_R = 15;
const RING_C = 2 * Math.PI * RING_R;
const ringFill = (n) => Math.max(0.1, 0.85 - n * 0.05);

// One home-screen page: icon grid (live apps link to their store, upcoming
// ones are dimmed with a progress ring) + a "Coming soon" note if needed.
export default function AppGrid({ apps }) {
  const t = useT();
  let soonIndex = 0;

  return (
    <>
      <div className="ml-grid">
        {apps.map((app) => {
          const url = storeUrl(app);
          if (url) {
            return (
              <a
                key={app.id}
                className="ml-icon"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                title={app.descKey ? `${app.name} — ${t(app.descKey)}` : app.name}
              >
                <img src={app.icon} alt="" width="88" height="88" loading="lazy" />
                <span>{app.short}</span>
              </a>
            );
          }
          const fill = ringFill(soonIndex++);
          return (
            <div key={app.id} className="ml-icon ml-icon-soon" title={`${app.name} — ${t("apps.soon")}`}>
              <span className="ml-icon-art">
                <img src={app.icon} alt="" width="88" height="88" loading="lazy" />
                <svg className="ml-ring" viewBox="0 0 40 40" aria-hidden="true">
                  <circle cx="20" cy="20" r="18.5" />
                  <circle
                    cx="20"
                    cy="20"
                    r={RING_R / 2}
                    strokeWidth={RING_R}
                    strokeDasharray={`${(fill * Math.PI * RING_R).toFixed(2)} ${RING_C}`}
                  />
                </svg>
              </span>
              <span>{app.short}</span>
            </div>
          );
        })}
      </div>

      {soonIndex > 0 && (
        <p className="ml-soon-note">
          <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
            <circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <path d="M8 8V1.5A6.5 6.5 0 0 1 14.5 8Z" fill="currentColor" />
          </svg>
          {t("apps.soon")}
        </p>
      )}
    </>
  );
}
